/**
 * TODO 使用组件
 */

import React, { Component } from 'react'
import throttle from 'lodash/throttle'
import { getBuyerNewgoods } from '@/apis/share.ts'
import appInstall from '@/utils/appUtils/appInstall'
import { copyText } from '@/utils/index'
import { isDuApp, compareVersion, getAppVersion } from '@/utils/appUtils/getDevice'
import Jockeys from '@/utils/jockey'
import { Toast } from 'antd-mobile'
import { EditConfigType, GlobalConfigType } from '@/typings/types'
import ProductItem from './ProductItem'
import styles from './index.module.less'
import { currencyCodeMap, currencySymbolMap } from '@/constant'

const imgFilter = (value, size) => {
  return `${value}?x-oss-process=image/resize,m_pad,h_${size},w_${size}`
}

const scrollD = 200 // 滚动请求伐值

interface IProductWrapperProps {
  editConfig: EditConfigType
  tabItemTitleBg: string
  globalConfig: GlobalConfigType
  pageId: string
  tabBarActiveTextColor: string
  groupName?: string
  bidIds?: any
}

class ProductWrapper extends Component<
  IProductWrapperProps,
  {
    pageSize: number
    page: number
    isEnd: boolean
    list: any[]
  }
> {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      page: 1, // 数据组从0开始
      pageSize: 18,
      isEnd: false,
    }
    this.scrollHandler = throttle(this.scrollHandler, 100)
  }
  componentDidMount() {
    this.getGoodList()
    this.initPagnationScroll()
  }

  isLoading = false

  initPagnationScroll = () => {
    window.addEventListener('scroll', this.scrollHandler)
  }

  scrollHandler = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
    if (scrollTop + windowHeight + scrollD >= scrollHeight) {
      this.onEndReached()
    }
  }

  onEndReached = () => {
    this.getGoodList()
  }

  getCurrency = () => {
    const local = this.props.editConfig.local
    return currencySymbolMap[local]
  }

  getGoodList = async () => {
    const { pageSize, page, isEnd } = this.state
    if (isEnd || this.isLoading) {
      return
    }
    this.isLoading = true
    const { lang, local } = this.props?.editConfig
    // debugger

    try {
      // const { status, data } = await getLatestBidList(
      const { status, data } = await getBuyerNewgoods(
        {
          countryCode: local,
          language: lang,
          currencyCode: currencyCodeMap[local],
          // page,
          // size: pageSize,
        },
        { language: lang, countryCode: local }
      )
      if (status === 200) {
        const nextPageList = (data?.children || []).map((item) => {
          return {
            itemNo: item.itemNo,
            cover: item.cover,
            spuId: item.spuId,
            title: item.title,
            price: item.price,
          }
        })
        // nextPageList.length === 0请求完毕
        // const isEnd = !nextPageList.length
        this.setState(({ page, list }) => {
          return {
            list: list.concat(nextPageList),
            page: page + 1,
            isEnd: true,
          }
        })
      }
    } catch (error) {
      console.error(error, 'error')
    } finally {
      this.isLoading = false
    }

    // const data = dataSource.data
    // const nextPageList = (data?.spuList || []).map(item => {
    //   return {
    //     itemNo: item.articleNumber,
    //     cover: item.logoUrl,
    //     spuId: item.spuId,
    //     title: item.title,
    //     price: item.productItemPriceView?.price
    //   }
    // })
    // // nextPageList.length === 0请求完毕
    // const isEnd1 = !nextPageList.length
    // this.setState(({ page, list }) => {
    //   return {
    //     list: list.concat(nextPageList),
    //     page: page + 1,
    //     isEnd: isEnd1,
    //   }
    // })
  }

  handleCover(url) {
    const newUrl = (url += imgFilter('', 200))
    return newUrl
  }

  handlePrice(price) {
    if (!price) return '--'
    return price / 100
  }

  goDetail = (params, itemNo) => {
    const { spuId } = params
    if (isDuApp() && compareVersion(getAppVersion(), '2.1.5') !== -1) {
      Jockeys.openNativePage('/sell/productDetail', {
        spuId,
      })
      return
    }

    if (isDuApp()) {
      const msg = '貨號已複製，暫僅可在首頁粘貼並搜索。'
      copyText(itemNo)
      Toast.info(msg)
      return
    }

    appInstall('/sell/productDetail', { spuId })
  }

  render() {
    const list = this.state.list
    const { globalConfig, pageId, tabItemTitleBg, groupName, tabBarActiveTextColor } = this.props
    return (
      <div className={styles.group}>
        {groupName ? (
          <div className={styles.title} style={{ color: tabBarActiveTextColor }}>
            {tabItemTitleBg && (
              <img className={styles['tab-item-title-bg']} src={tabItemTitleBg} alt="" />
            )}
            <span style={{ position: 'relative', zIndex: 2 }}>{groupName}</span>
          </div>
        ) : null}
        <div className={styles.desc}>
          {list.map(({ itemNo, cover, spuId, title, price }, index) => (
            <ProductItem
              itemNo={itemNo}
              index={index}
              cover={cover}
              spuId={spuId}
              title={title}
              price={price}
              handleCover={this.handleCover}
              handlePrice={this.handlePrice}
              getCurrency={this.getCurrency}
              goDetail={this.goDetail}
              globalConfig={globalConfig}
              pageId={pageId}
              key={spuId}
            />
          ))}
        </div>
      </div>
    )
  }
}

export default ProductWrapper
